export const PATIENT_INACTIVATION_TYPE = Object.freeze({
  RATE_LIMIT: "RATE_LIMIT",
  ACCESS_REVOKED: "ACCESS_REVOKED",
});

export const PATIENT_STATUS = Object.freeze({
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
});
